import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "components/shared/toast/toast";
import { TRAINING } from "services/apiEndpoints";
import { privateGet } from "services/privateRequest";
import { makeQueryString } from "utils/utils";

const initialState = {
    training: [],
    isFetching: false,
    filterValues: {},
    trainingFilter: {
        totalCount: 0,
        pageNumber: 1,
        limit: 10,
        status: "idle", // 'idle' | 'loading' | 'error'
    },
    selectedAnnouncementId: {},
};
export const fetchTrainingList = createAsyncThunk(
    "training/fetchTrainingList",
    async (payload, { rejectWithValue, dispatch }) => {
        try {
            const queryString = makeQueryString(TRAINING, payload);
            const response = await privateGet(queryString);

            dispatch(
                setTrainingPagination({
                    pageNumber: payload.pageNumber,
                    limit: payload.limit,
                    totalCount: response.data.data?.totalCount
                })
            );

            return response.data.data.result;
        } catch (error) {
            console.error("Error fetching form data:", error);
            rejectWithValue(error);
        }
    }
);



const trainingSlice = createSlice({
    name: "training",
    initialState,
    reducers: {
        setIsFetching: (state, action) => {
            state.isFetching = action.payload;
        },
        clearTraining: (state) => {
            state.training = [];
        },
        setTrainingPagination: (state, action) => {
            state.trainingFilter.pageNumber = action.payload.pageNumber;
            state.trainingFilter.limit = action.payload.limit;
            state.trainingFilter.totalCount = action.payload.totalCount;
        }
    },
    extraReducers: {
        [fetchTrainingList.pending]: (state) => {
            state.trainingFilter.status = "loading";
        },
        [fetchTrainingList.fulfilled]: (state, action) => {
            state.trainingFilter.status = "idle";
            state.training = action?.payload;
        },
        [fetchTrainingList.rejected]: (state) => {
            state.trainingFilter.status = "error";
        },
    },
});

export default trainingSlice.reducer;
export const {
    setIsFetching,
    setFilterValues,
    setTrainingPagination,
    clearTraining
} = trainingSlice.actions;
